<template>
    <div class="vehicle-card-wrapper">
        <div
            :class="cardClasses"
            @click="selectVehicle"
        >
            <!-- Imagem do Veículo -->
            <div class="vehicle-image">
                <img
                    :src="vehicle.photo || defaultImage"
                    :alt="`Imagem do ${vehicle.model || 'Veículo'}`"
                    class="img-fluid"
                    @error="handleImageError"
                />

                <!-- Badge de Selecionado -->
                <!--                <div v-if="isSelected" class="selected-badge me">-->
                <!--                    <i class="fas fa-check-circle mr-2"></i>-->
                <!--                    Selecionado-->
                <!--                </div>-->

                <!-- Badge de Consulta -->

                <!-- Badge de Aprovação Necessária -->
                <div
                    v-if="requiresApprover"
                    class="approval-badge"
                >
                    <i class="fas fa-user-check mr-2"></i>
                    Requer Aprovação
                </div>

                <!-- Badge de Veículo Executivo -->
                <div
                    v-if="vehicle.is_executive"
                    class="executive-badge"
                    :class="{ 'with-approval': requiresApprover }"
                >
                    <i class="fas fa-crown mr-2"></i>
                    Executivo
                </div>
            </div>

            <!-- Informações do Veículo -->
            <div class="vehicle-info p-3">
                <h6 class="vehicle-title">
                    {{ (this.$store.state.user.access_nivel > 2 || isNotShared) && vehicle ? vehicle.model : `Veículo ${index + 1}` }}
                </h6>

                <div class="vehicle-details">
                    <!-- Placa (com regra de ocultação para locação) -->
                    <div
                        class="detail-item"
                        v-if="(this.$store.state.user.access_nivel > 2 || isNotShared) && vehicle"
                    >
                        <i class="fas fa-id-card-alt detail-icon"></i>
                        <span class="detail-label">Placa:</span>
                        <span class="detail-value">{{ vehicle.board || 'N/A' }}</span>
                    </div>

                    <!-- Lugares -->
                    <div class="detail-item">
                        <i class="fas fa-users detail-icon"></i>
                        <span class="detail-label">Lugares:</span>
                        <span class="detail-value">{{ vehicle.places }}</span>
                    </div>

                    <!-- Cor -->
                    <div
                        class="detail-item"
                        v-if="vehicle.color"
                    >
                        <i class="fas fa-palette detail-icon"></i>
                        <span class="detail-label">Cor:</span>
                        <span class="detail-value">{{ vehicle.color }}</span>
                    </div>

                    <!-- Centro de Custo -->
                    <div
                        class="detail-item"
                        v-if="vehicle.cost_center"
                    >
                        <i class="fas fa-building detail-icon"></i>
                        <span class="detail-label">Centro de Custo:</span>
                        <span class="detail-value">{{ vehicle.cost_center.description }}</span>
                    </div>

                    <!-- Combustível -->
                    <div
                        class="detail-item"
                        v-if="vehicle.combustible"
                    >
                        <i class="fas fa-gas-pump detail-icon"></i>
                        <span class="detail-label">Combustível:</span>
                        <span class="detail-value">{{ vehicle.combustible }}</span>
                    </div>
                </div>

                <!-- Botões de Ação -->
                <div class="vehicle-actions mt-3 d-flex justify-content-center">
                    <button
                        type="button"
                        :class="selectButtonClasses"
                        @click.stop="selectVehicle"
                    >
                        <i
                            :class="selectButtonIcon"
                            class="mr-2"
                        ></i>
                        {{ selectButtonText }}
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VehicleCard',
    props: {
        vehicle: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        isSelected: {
            type: Boolean,
            default: false
        },
        isConsultationOnly: {
            type: Boolean,
            default: false
        },
        requiresApprover: {
            type: Boolean,
            default: false
        },
        isNotShared: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            imageError: false, // Controla se houve erro no carregamento da imagem
            defaultImage: '/images/default-car.png' // Imagem padrão para carros
        };
    },
    computed: {
        // Classes CSS do cartão
        cardClasses() {
            return [
                'vehicle-card vehicle-clickable',
                {
                    'vehicle-selected': this.isSelected,
                }
            ];
        },

        // Classes do botão de seleção
        selectButtonClasses() {
            return [
                'btn', 'btn-sm', 'me-2',
                this.isSelected ? 'btn-success' : 'btn-primary'
            ];
        },

        // Ícone do botão de seleção
        selectButtonIcon() {
            return this.isSelected ? 'fas fa-check' : 'fas fa-mouse-pointer';
        },

        // Texto do botão de seleção
        selectButtonText() {
            return this.isSelected ? 'Selecionado' : 'Selecionar';
        }
    },
    methods: {
        // Seleciona o veículo
        selectVehicle() {
            console.log('etr')
            this.$emit('select', this.vehicle);
        },

        // Exibe detalhes do veículo
        showDetails() {
            this.$emit('show-details', this.vehicle);
        },

        // Manipula erro de carregamento da imagem
        handleImageError(event) {
            this.imageError = true;
            event.target.src = this.defaultImage;
        }
    }
};
</script>

<style scoped>
.vehicle-card-wrapper {
    height: 100%;
}

.vehicle-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;
    border: 2px solid #e9ecef;
    background: #ffffff;
}

.vehicle-clickable {
    cursor: pointer;
}

.vehicle-clickable:hover {
    transform: translateY(-8px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    border-color: #FD7D14;
}

.vehicle-selected {
    border: 2px solid #28a745;
    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
    transform: translateY(-5px);
}

.vehicle-consultation {
    opacity: 0.8;
    border-color: #6c757d;
}

.vehicle-consultation:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

/* Seção da Imagem */
.vehicle-image {
    position: relative;
    height: 200px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.vehicle-image img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    transition: transform 0.3s ease;
}

.vehicle-clickable:hover .vehicle-image img {
    transform: scale(1.05);
}

/* Badges */
.selected-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    color: white;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(40, 167, 69, 0.4);
    animation: pulse 2s infinite;
}

.consultation-badge {
    position: absolute;
    top: 12px;
    left: 12px;
    background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
    color: white;
    padding: 4px 10px;
    border-radius: 15px;
    font-size: 11px;
    font-weight: 500;
}

.approval-badge {
    position: absolute;
    top: 12px;
    left: 12px;
    background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
    color: #212529;
    padding: 4px 10px;
    border-radius: 15px;
    font-size: 11px;
    font-weight: 600;
}

.executive-badge {
    position: absolute;
    top: 12px;
    right: 12px;
    background: linear-gradient(135deg, #6f42c1 0%, #8e44ad 100%);
    color: white;
    padding: 4px 10px;
    border-radius: 15px;
    font-size: 11px;
    font-weight: 600;
    box-shadow: 0 2px 4px rgba(111, 66, 193, 0.3);
}

/* Informações do Veículo */
.vehicle-info {
    background-color: #ffffff;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.vehicle-title {
    font-weight: 700;
    margin-bottom: 15px;
    color: #2c3e50;
    font-size: 1.1rem;
    text-align: center;
    border-bottom: 2px solid #e9ecef;
    padding-bottom: 8px;
}

.vehicle-details {
    flex-grow: 1;
}

.detail-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    font-size: 13px;
    padding: 4px 0;
}

.detail-icon {
    color: #6c757d;
    width: 16px;
    margin-right: 8px;
    font-size: 12px;
}

.detail-label {
    font-weight: 600;
    color: #495057;
    margin-right: 6px;
    min-width: 70px;
    width: 120px;
}

.detail-value {
    color: #6c757d;
    flex: 1;
}

/* Ações do Veículo */
.vehicle-actions {
    display: flex;
    gap: 8px;
    justify-content: space-between;
    border-top: 1px solid #e9ecef;
    padding-top: 12px;
}

.btn {
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s ease;
    font-size: 12px;
    padding: 6px 12px;
}

.btn-success {
    background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
    border: none;
}

.btn-outline-info {
    border-color: #17a2b8;
    color: #17a2b8;
}

.btn-outline-info:hover {
    background-color: #17a2b8;
    color: white;
    transform: translateY(-1px);
}

/* Animações */
@keyframes pulse {
    0% {
        box-shadow: 0 2px 8px rgba(40, 167, 69, 0.4);
    }
    50% {
        box-shadow: 0 2px 8px rgba(40, 167, 69, 0.8);
    }
    100% {
        box-shadow: 0 2px 8px rgba(40, 167, 69, 0.4);
    }
}

/* Responsividade */
@media (max-width: 768px) {
    .vehicle-image {
        height: 150px;
    }

    .vehicle-title {
        font-size: 1rem;
    }

    .detail-item {
        font-size: 12px;
    }

    .detail-label {
        min-width: 60px;
    }

    .vehicle-actions {
        flex-direction: column;
        gap: 6px;
    }

    .btn {
        font-size: 11px;
        padding: 5px 10px;
    }
}

@media (max-width: 576px) {
    .vehicle-card {
        margin-bottom: 15px;
    }

    .selected-badge,
    .consultation-badge,
    .approval-badge,
    .executive-badge {
        font-size: 10px;
        padding: 3px 8px;
    }

    .vehicle-image {
        height: 120px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/add-components/VehicleCard.vue